import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import pt from './pt.json';
import es from './es.json';

const messages = {
    pt,
    es
};

const userLocale = navigator.language || navigator.userLanguage;
// const defaultLanguage = 'es'
const defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE
const userLanguage = localStorage.getItem("default-lang")

const i18n = new VueI18n({
    locale: userLanguage || userLocale.split('-')[0],
    fallbackLocale: defaultLanguage,
    messages,
});

export default i18n;
